let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cdxh0")).then(() => parcelRequire('7iBoV'));